import React, { useState, useEffect } from 'react';
import Icon from '../../../../components/AppIcon';

const EmailValidator = ({ email }) => {
  if (!email) return null;

  const isValid = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email);

  return (
    <div className="mt-2">
      {isValid ? (
        <div className="flex items-center space-x-2">
          <Icon name="CheckCircle" size={16} className="text-success flex-shrink-0" />
          <span className="text-success text-sm">Valid email format</span>
        </div>
      ) : (
        <div className="flex items-center space-x-2">
          <Icon name="AlertCircle" size={16} className="text-error flex-shrink-0" />
          <span className="text-error text-sm">Please enter a valid email address</span>
        </div>
      )}
    </div>
  );
};

export default EmailValidator;